import React from "react";

import theme from "config/theme";

import { ButtonSimple } from "components/Button";

import { Wrapper, Inner, Title, Description, Image } from "./styles";

const Article = ({ content }) => {
  const excerpt = content.description.substring(0, 250);
  return (
    <Wrapper href={content.link} target="_blank">
      <Image
        src={content.thumbnail}
        bg={theme.color.gray2}
        placeholder="medium"
        height="160px"
      />
      <Inner>
        <Title dangerouslySetInnerHTML={{ __html: content.title }} />
        <Description dangerouslySetInnerHTML={{ __html: `${excerpt}...` }} />
        <ButtonSimple color={theme.color.gray2}>Read Article →</ButtonSimple>
      </Inner>
    </Wrapper>
  );
};

export default Article;
